export const COUPON_DETAILS_GET_REQUEST = ' COUPON_DETAILS_GET_REQUEST';
export const COUPON_DETAILS_GET_SUCCESS = ' COUPON_DETAILS_GET_SUCCESS';
